import http from 'util/http'
/**
 * 搜索接口
 * @param {string} word 关键字
 * @param {string} type 搜索类型
 * @param {object} param0
 * @param {number} param0.pageindex 分页的起始索引
 * @param {number} param0.pagesize 每页返回的行数
 * @param {number} sort 排序
 */
export function search(params) {
  return http.get('/newxyrj/public/article/search', params)
}

/** 获取热门搜索关键字 */
export function getHot() {
  return http.get('/newxyrj/public/article/search/hot', {})
}

/** 联想关键词 */
export function getThink(keywords) {
  return http.get('/newxyrj/public/fancy/keywords/list', { keywords })
}
